export default {"src":"/_next/static/media/image-cimigo.e7202114.svg","height":198,"width":332,"blurWidth":0,"blurHeight":0};